import * as React from "react";
const SvgStepDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 14, cy: 14, r: 12, fill: "currentColor", stroke: "white", strokeWidth: 4 }));
export default SvgStepDot;
